var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',{class:{'grey lighten-3': _vm.$vuetify.theme.dark},attrs:{"id":"pages"}},[_c('v-img',{class:{
        'v-image--sm': this.$vuetify.breakpoint.smAndDown,
        'v-image--md': this.$vuetify.breakpoint.mdAndDown},style:({
          paddingTop: _vm.$isScreenPortrait() ? '64px' : '0px',
          paddingBottom: _vm.$isScreenPortrait() ? '88px' : '0px'
          }),attrs:{"src":require(`@/assets/${_vm.src || 'clint-mckoy.jpg'}`),"gradient":"to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)","min-height":"100%"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }